export interface FAQItem {
    question: string;
    answer: string;
}

export interface FAQSection {
    section: string;
    items: FAQItem[];
}

const faqs: FAQSection[] = [
    {
        section: 'login',
        items: [
            {
                question: 'question1',
                answer: 'answer1'
            },
            {
                question: 'question2',
                answer: 'answer2'
            }
        ]
    },
    {
        section: 'user',
        items: [
            {
                question: 'question1',
                answer: 'answer1'
            },
            {
                question: 'question2',
                answer: 'answer2'
            },
            {
                question: 'question3',
                answer: 'answer3'
            },
            {
                question: 'question4',
                answer: 'answer4'
            },
            {
                question: 'question5',
                answer: 'answer5'
            }
        ]
    },
    {
        section: 'files',
        items: [
            {
                question: 'question1',
                answer: 'answer1'
            },
            {
                question: 'question2',
                answer: 'answer2'
            },
            {
                question: 'question3',
                answer: 'answer3'
            },
            {
                question: 'question4',
                answer: 'answer4'
            },
            {
                question: 'question5',
                answer: 'answer5'
            },
            {
                question: 'question6',
                answer: 'answer6'
            }
        ]
    },
    {
        section: 'banks',
        items: [
            {
                question: 'question1',
                answer: 'answer1'
            }
        ]
    },
    {
        section: 'corporates',
        items: [
            {
                question: 'question1',
                answer: 'answer1'
            },
            {
                question: 'question2',
                answer: 'answer2'
            },
            {
                question: 'question3',
                answer: 'answer3'
            }
        ]
    },
    {
        section: 'campaigns',
        items: [
            {
                question: 'question1',
                answer: 'answer1'
            },
            {
                question: 'question2',
                answer: 'answer2'
            }
        ]
    },
    {
        section: 'report',
        items: [
            {
                question: 'question1',
                answer: 'answer1'
            },
            {
                question: 'question2',
                answer: 'answer2'
            },
            {
                question: 'question3',
                answer: 'answer3'
            }
        ]
    }
];

export default faqs;
